(function(){
  function txt(el){ return el ? (el.textContent || '').trim() : ''; }

  /* Translated strings are handed over by snippets/pp-reviews-style.liquid.
     A key the locale files do not have yet arrives as "Translation missing:
     en.pp_reviews..." (capital T, hence the case-insensitive match), and any
     such value falls back to the English default instead of reaching the page. */
  var I18N = window.ppReviewsI18n || {};
  function tr(key, fallback){
    var v = I18N[key];
    return (typeof v === 'string' && v && !/translation missing/i.test(v)) ? v : fallback;
  }

  function node(tag, cls, text){
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  /* `paths` is always a constant from this file, never review data */
  function icon(cls, paths){
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    s.innerHTML = paths;
    return s;
  }

  /* One inline !important declaration, written only when it differs.
     main-product.liquid restyles the same Judge.me nodes on a timer of its
     own, so ours are re-asserted on a timer too - and rewriting identical
     values on every pass would dirty the widget's subtree for nothing. */
  function force(el, prop, val){
    if (el.style.getPropertyValue(prop) !== val || el.style.getPropertyPriority(prop) !== 'important') {
      el.style.setProperty(prop, val, 'important');
    }
  }

  /* ================= REVIEW QUERY =================
     The Filter panel owns the reviews query, not the Judge.me widget. Every
     reviews request the widget sends for this product passes through the
     fetch wrapper below, which writes the panel's sort, rating and search
     onto it - so the first page, every "Show more" page and any refetch the
     widget does by itself all carry the same query. After a change the panel
     makes the widget fetch again by flipping the widget's own hidden sort
     <select>; the wrapper then overrides whatever that select asked for.

     Why not drive the widget's own controls: it has no oldest-first sort (its
     endpoint does honour sort_dir=asc), its search box is switched off, and a
     scripted tap on a histogram bar only filtered on the first tap.

     Photos & videos is a sort in Judge.me (sort_by=with_pictures, newest
     first), not a filter, so it cannot combine with another sort: ticking it
     sets Sort by to Newest, choosing a sort unticks it. It starts ticked.

     window.__ppReviewQuery and __ppReviewFetch are the same globals the
     NICHES theme's copy of this panel (inline in its main-product.liquid)
     uses. If that copy ever lands in this theme as well, the two share one
     query and one wrapper, and whichever runs first builds the button. */
  function productId(){
    var w = document.querySelector('.jdgm-review-widget[data-product-id]');
    if (w) return w.getAttribute('data-product-id') || '';
    var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    return m && m.id ? String(m.id) : '';
  }

  var SORTS = [
    { value: 'newest',  label: tr('sortNewest', 'Newest'),   by: 'created_at', dir: 'desc' },
    { value: 'oldest',  label: tr('sortOldest', 'Oldest'),   by: 'created_at', dir: 'asc' },
    { value: 'highest', label: tr('sortHighest', 'Highest'), by: 'rating',     dir: 'desc' },
    { value: 'lowest',  label: tr('sortLowest', 'Lowest'),   by: 'rating',     dir: 'asc' }
  ];
  var RATINGS = [
    { value: '',  label: tr('ratingAll', 'All') },
    { value: '1', label: tr('stars1', '1 star') },
    { value: '2', label: tr('stars2', '2 stars') },
    { value: '3', label: tr('stars3', '3 stars') },
    { value: '4', label: tr('stars4', '4 stars') },
    { value: '5', label: tr('stars5', '5 stars') }
  ];

  var Q = window.__ppReviewQuery || (window.__ppReviewQuery = {
    sort: 'newest', photos: true, rating: '', search: '', requests: 0
  });

  if (!window.__ppReviewFetch && typeof window.fetch === 'function') {
    window.__ppReviewFetch = true;
    var nativeFetch = window.fetch;
    window.fetch = function(input, init){
      try {
        var url = typeof input === 'string' ? input : (input instanceof URL ? input.href : (input && input.url));
        if (url && url.indexOf('reviews_for_widget') !== -1) {
          var u = new URL(url, window.location.href);
          var pid = productId();
          if (pid && u.searchParams.get('product_id') === pid) {
            /* kept before rewriting: the photos strip builds its own request
               from the widget's real one (shop domain, locale, cache stamp) */
            window.__ppReviewWidgetUrl = u.toString();
            var p = u.searchParams;
            var sort = SORTS.filter(function(s){ return s.value === Q.sort; })[0] || SORTS[0];
            if (Q.photos) { p.set('sort_by', 'with_pictures'); p.delete('sort_dir'); }
            else { p.set('sort_by', sort.by); p.set('sort_dir', sort.dir); }
            if (Q.rating) p.set('filter_rating', Q.rating); else p.delete('filter_rating');
            if (Q.search) p.set('search', Q.search); else p.delete('search');
            Q.requests++;
            input = (typeof input === 'string' || input instanceof URL) ? u.toString() : new Request(u.toString(), input);
          }
        }
      } catch (e) {}
      var res = nativeFetch.call(window, input, init);
      /* the widget shows each review photo as a small thumbnail but loads its "original" at 1024px (~200-290 KB each,
         ~900 KB per page on PageSpeed, 7 Oct 2026); Judge.me's image server resizes on ?width=, so the thumbnails get
         360px (~25 KB). The "huge" size the enlarged view uses stays 1024. */
      try {
        var ru = typeof input === 'string' ? input : (input instanceof URL ? input.href : (input && input.url));
        if (ru && ru.indexOf('reviews_for_widget') !== -1) {
          return res.then(function(r){
            return r.clone().text().then(function(t){
              var t2 = t.replace(/("original"\s*:\s*"[^"]*?width=)1024/g, '$1360');
              if (t2 === t) return r;
              return new Response(t2, { status: r.status, statusText: r.statusText, headers: r.headers });
            }).catch(function(){ return r; });
          });
        }
      } catch (e) {}
      return res;
    };
  }

  function refetch(){
    var s = document.querySelector('.jm-sort-filter select');
    if (!s) return;
    s.value = s.value === 'created_at' ? 'highest_rating' : 'created_at';
    s.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* 1) Editorial summary: big 4.8 (left) + stars over "Based on N reviews" (right), centered */
  function buildSummary(){
    try{
      var c = document.querySelector('.jm-average-rating-display__content');
      if(!c || c.querySelector('.pp-jm-sum')) return;
      var avgEl = null, ctEl = null;
      c.querySelectorAll('*').forEach(function(el){
        if(el.children.length) return;
        var t = txt(el);
        if(!t) return;
        if(!avgEl && /^\d+([.,]\d+)?$/.test(t)) { avgEl = el; return; }
        /* The count line used to be found with /review/i, which only ever
           matched English - in French Judge.me renders "Basé sur 3 038 avis",
           so ctEl stayed null and the line rendered empty. Match on "a leaf
           that still contains a digit" instead, which holds in every language. */
        if(!ctEl && /\d/.test(t)) ctEl = el;
      });
      var stars = c.querySelector('.jm-star-rating') || ((c.querySelector('.jm-star-rating__font-icon') || {}).parentNode);
      if(!avgEl || !stars) return;
      var ctNum = '';
      /* Thousands separators differ per locale: "3,038" / "3.038" / "3 038"
         with a normal, non-breaking or narrow no-break space. */
      if (ctEl) { var cm = txt(ctEl).match(/\d[\d.,  \s]*\d|\d/); if (cm) ctNum = cm[0].trim(); }
      var wrap = document.createElement('div'); wrap.className = 'pp-jm-sum';
      var big = document.createElement('span'); big.className = 'pp-jm-big'; big.textContent = txt(avgEl);
      var meta = document.createElement('span'); meta.className = 'pp-jm-meta';
      meta.appendChild(stars.cloneNode(true));
      var ct = document.createElement('span'); ct.className = 'pp-jm-ct';
      /* "3.129 reviews", not "Based on 3.129 reviews". Rather than add a new
         translation key, the existing one is trimmed to start at the number -
         every localisation of it puts the count mid-string with a lead-in, so
         slicing from the placeholder drops the lead-in in any language. */
      var tpl = (window.ppReviewsI18n && window.ppReviewsI18n.basedOn) || 'Based on %%N%% reviews';
      var at = tpl.indexOf('%%N%%');
      if (at > 0) tpl = tpl.slice(at);

      /* One plain run of text - the number is no longer wrapped in <b>. The
         count is a caption under the stars, and a bold figure inside it read
         as a second headline competing with the average above. textContent,
         so the count never goes through the HTML parser. */
      ct.textContent = ctNum ? tpl.split('%%N%%').join(ctNum) : txt(ctEl);
      meta.appendChild(ct);
      wrap.appendChild(big); wrap.appendChild(meta);
      c.innerHTML = ''; c.appendChild(wrap);
    }catch(e){}
  }

  /* 1b) Histogram rows: a digit instead of five star glyphs, and no count on
     the right. Five rows of five stars each is 25 identical marks competing
     with the average above them; the bar already carries the proportion, so
     the number on the right was a third encoding of the same fact.
     The digit comes from the row's own aria-label ("5 out of 5 stars"), which
     is the only place Judge.me states it in text. */
  function styleHistogram(){
    try{
      document.querySelectorAll('.jm-histogram-row').forEach(function(row){
        if (row.getAttribute('data-pp-digit')) return;
        var sr = row.querySelector('.jm-star-rating');
        if (!sr) return;
        var m = (sr.getAttribute('aria-label') || '').match(/(\d)\s*out of/i);
        if (!m) return;
        var d = document.createElement('span');
        d.className = 'pp-jm-histo-n';
        d.textContent = m[1];
        row.replaceChild(d, sr);
        row.setAttribute('data-pp-digit', '1');
      });
    }catch(e){}
  }

  /* 2a) Move the summary photo gallery above the Write-a-review row */
  function moveGallery(){
    try{
      var gallery = document.querySelector('.jm-media-grid');
      var actions = document.querySelector('.jm-action-buttons');
      if(gallery && actions && actions.parentNode && gallery.parentNode && gallery.nextElementSibling !== actions){
        actions.parentNode.insertBefore(gallery, actions);
      }
    }catch(e){}
  }

  /* 2b) Move the UGC video strip out of the stats section and down to sit
     directly above the Write-a-review row, so the videos are the last thing
     seen before the review list.
     The strip's CSS is scoped to .ppsm-<section-id>, so it is re-parented
     INSIDE a clone of that wrapper class - move it bare and it loses every
     rule it has. */
  function moveVideoStrip(){
    try{
      var strip = document.querySelector('[class*="ppsm-"] .marquee');
      if(!strip || document.querySelector('.pp-strip-host')) return;
      var actions = document.querySelector('.jm-action-buttons');
      if(!actions || !actions.parentNode) return;

      var src = strip.closest('[class*="ppsm-"]');
      var host = document.createElement('div');
      host.className = 'pp-strip-host ' + (src ? src.className : '');
      actions.parentNode.insertBefore(host, actions);
      host.appendChild(strip);

      /* The marquee is rAF driven and caches the width of one full set at
         init. Re-parenting changes that width, which leaves the scroller
         wrapping at the old point - it looks stuck or clipped. The section
         re-measures on resize, so say so. */
      window.dispatchEvent(new Event('resize'));
      setTimeout(function(){ window.dispatchEvent(new Event('resize')); }, 400);
    }catch(e){}
  }

  /* 2c) Put the 4.8 cluster and the histogram on ONE row at every width.
     They are in different containers by default - the average sits in
     __summary-section, the bars in __main-content - which is why mobile
     stacks them. Moving the histogram up into the summary section is what
     lets them share a row WITHOUT dragging the Write-a-review button into
     a narrow column with them. */
  function moveHistogram(){
    try{
      var summary = document.querySelector('.jm-review-widget-header__summary-section');
      var hist = document.querySelector('.jm-histogram');
      if(!summary || !hist || summary.contains(hist)) return;
      summary.appendChild(hist);
      summary.classList.add('pp-summary-row');
    }catch(e){}
  }

  /* 2) Move the sort/filter control onto the Write-a-review row */
  function moveSort(){
    try{
      var actions = document.querySelector('.jm-action-buttons');
      var sort = document.querySelector('.jm-filters__buttons');
      if(actions && sort && !actions.classList.contains('pp-actions-row')){
        actions.classList.add('pp-actions-row');
        actions.appendChild(sort);
      }
    }catch(e){}
  }

  /* 2d) Stacked at every width: Write a review, the photos strip, then Filter.
     main-product.liquid used to force this row to flex-direction:row inline
     from a layout poll; that poll was deleted on 14 Sep 2026. The stack is
     still asserted inline, on a timer of its own (see start), so no leftover
     inline !important can put the row back side by side. */
  function layout(){
    try{
      var actions = document.querySelector('.jm-action-buttons.pp-actions-row');
      if(!actions) return;
      force(actions, 'display', 'flex');
      force(actions, 'flex-direction', 'column');
      force(actions, 'align-items', 'stretch');
      force(actions, 'gap', '16px');
      for(var i = 0; i < actions.children.length; i++){
        var k = actions.children[i];
        force(k, 'width', '100%');
        force(k, 'max-width', 'none');
        force(k, 'flex', '0 0 auto');
      }
    }catch(e){}
  }

  /* ================= FILTER =================
     One Filter button opens a panel with Search, Sort by (Newest / Oldest /
     Highest / Lowest), Rating (All, 1-5 stars) and Photos & videos. It sits
     where Judge.me's own sort control was; that control stays in the page,
     visually hidden, because refetch() flips it to make the widget reload. */
  function histogramRows(){
    var h = document.querySelector('.jm-review-widget-header__star-rating-histogram');
    return h ? Array.prototype.slice.call(h.querySelectorAll('.jm-histogram-row')) : [];
  }
  /* The chosen rating's row stays solid and the others fade. Not a
     background on the chosen row: that spans the digit as well, so it read
     as a bar wider than the rest. */
  function paintHistogram(){
    histogramRows().forEach(function(row, i){
      var o = (Q.rating && String(5 - i) !== Q.rating) ? '0.35' : '';
      if (row.style.opacity !== o) row.style.opacity = o;
      if (!row.style.transition) row.style.transition = 'opacity .2s ease';
    });
  }

  /* A select box: label and current choice shown as text, the real <select>
     laid invisibly over the whole box so a tap anywhere on it opens the
     phone's own picker (see the CSS). */
  function selectField(label, options, value, onChange){
    var field = node('div', 'pp-jm-field pp-jm-field--select');
    var text = node('span', 'pp-jm-field__text', label + ':');
    var shown = node('b');
    text.appendChild(shown);
    var select = node('select');
    select.setAttribute('aria-label', label);
    options.forEach(function(o){
      var opt = node('option', null, o.label);
      opt.value = o.value;
      select.appendChild(opt);
    });
    field.setValue = function(v){
      select.value = v;
      var opt = select.options[select.selectedIndex];
      shown.textContent = opt ? opt.text : '';
    };
    field.setValue(value);
    select.addEventListener('change', function(){
      field.setValue(select.value);
      onChange(select.value);
    });
    field.appendChild(text);
    field.appendChild(icon('pp-jm-field__chev', '<path d="M6 9l6 6 6-6"/>'));
    field.appendChild(select);
    return field;
  }

  /* set by buildBody: pushes Q back into the panel's fields after something
     other than the panel changed the query (the photos strip does) */
  var panelSync = null;

  function buildBody(){
    var body = node('div', 'pp-jm-filter-body');

    var search = node('div', 'pp-jm-field pp-jm-field--search');
    search.appendChild(icon('pp-jm-field__ico', '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/>'));
    var input = node('input');
    input.type = 'search';
    input.placeholder = tr('search', 'Search');
    input.autocomplete = 'off';
    input.setAttribute('aria-label', tr('search', 'Search'));
    input.setAttribute('enterkeyhint', 'search');
    input.value = Q.search;
    search.appendChild(input);
    var searchTimer;
    function commitSearch(){
      clearTimeout(searchTimer);
      var v = input.value.trim();
      if (v === Q.search) return;
      Q.search = v;
      refetch();
    }
    input.addEventListener('input', function(){
      clearTimeout(searchTimer);
      searchTimer = setTimeout(commitSearch, 500);
    });
    input.addEventListener('keydown', function(e){
      if (e.key !== 'Enter') return;
      e.preventDefault();
      commitSearch();
      input.blur();
    });

    var photos = node('input');
    var sortField = selectField(tr('sortBy', 'Sort by'), SORTS, Q.sort, function(v){
      Q.sort = v;
      Q.photos = false;
      photos.checked = false;
      refetch();
    });
    var ratingField = selectField(tr('rating', 'Rating'), RATINGS, Q.rating, function(v){
      Q.rating = v;
      paintHistogram();
      refetch();
    });

    var check = node('label', 'pp-jm-check');
    photos.type = 'checkbox';
    photos.checked = Q.photos;
    var box = node('span', 'pp-jm-check__box');
    box.appendChild(icon(null, '<path d="M5 12.5l4.5 4.5L19 7.5"/>'));
    check.appendChild(photos);
    check.appendChild(box);
    check.appendChild(node('span', null, tr('photos', 'Photos & videos')));
    photos.addEventListener('change', function(){
      Q.photos = photos.checked;
      if (Q.photos) { Q.sort = 'newest'; sortField.setValue('newest'); }
      refetch();
    });

    body.appendChild(search);
    body.appendChild(sortField);
    body.appendChild(ratingField);
    body.appendChild(check);
    panelSync = function(){
      input.value = Q.search;
      sortField.setValue(Q.sort);
      ratingField.setValue(Q.rating);
      photos.checked = Q.photos;
    };
    return body;
  }

  /* Open and closed are a class on the wrapper, styled in the CSS. The NICHES
     copy set the panel's display inline because a rule in the stylesheet hid
     it - that rule was the [class*="jm-filter-panel"] match in
     pp-reviews-style.css, which also caught .pp-jm-filter-panel, and it is now
     scoped to exclude it. inert keeps the collapsed fields out of the tab order. */
  function buildFilter(parent, before){
    var wrap = node('div', 'pp-jm-filter');
    var btn = node('button', 'pp-jm-filter-btn');
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.appendChild(icon('pp-jm-filter-btn__ico', '<path d="M4 6h16M7 12h10M10 18h4"/>'));
    btn.appendChild(node('span', null, tr('filter', 'Filter')));

    var panel = node('div', 'pp-jm-filter-panel');
    var inner = node('div', 'pp-jm-filter-inner');
    inner.inert = true;
    inner.appendChild(buildBody());
    panel.appendChild(inner);
    wrap.appendChild(btn);
    wrap.appendChild(panel);
    parent.insertBefore(wrap, before);

    btn.addEventListener('click', function(){
      var open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      inner.inert = !open;
    });
  }

  function ensureFilter(){
    try{
      var sortFilter = document.querySelector('.jm-sort-filter');
      if (!sortFilter) return;
      if (!sortFilter.classList.contains('pp-jm-native-hidden')) {
        sortFilter.classList.add('pp-jm-native-hidden');
        sortFilter.setAttribute('aria-hidden', 'true');
        var nativeSelect = sortFilter.querySelector('select');
        if (nativeSelect) nativeSelect.tabIndex = -1;
      }
      paintHistogram();
      var parent = sortFilter.parentElement;
      if (!parent || parent.querySelector('.pp-jm-filter')) return;
      buildFilter(parent, sortFilter);
      /* The widget's first request can go out before the wrapper existed:
         fetch once more so the default (photo reviews) applies. */
      if (!Q.requests) refetch();
    }catch(e){}
  }

  /* ================= CUSTOMER PHOTOS STRIP =================
     A swipeable row of square photos between Write a review and Filter, with
     a hairline above and below it. Every photo is from this product's real
     Judge.me reviews - the widget's own photo gallery is switched off for
     this store (photo_gallery is null in its payload), so there is no native
     component to restyle.

     The photos are page 1 of the "with pictures" query, which is the same
     first page the review list loads by default. So every tile's review is
     rendered in the list below, and a tap opens it in Judge.me's own viewer
     by tapping that review's thumbnail on the visitor's behalf. */
  var strip = { state: 'idle', items: [], host: null };
  var STRIP_MAX = 16;

  /* Only Judge.me's review-image host is accepted - never a placeholder, and
     never an arbitrary address from the payload. Width goes up to 240 so a
     tile stays sharp on a 2x screen; the payload's small size is 160. */
  function reviewImage(src){
    try{
      var u = new URL(src);
      if (u.protocol !== 'https:' || !/(^|\.)judgeme\.com$/i.test(u.hostname)) return '';
      if (u.searchParams.has('width')) u.searchParams.set('width', '240');
      return u.toString();
    }catch(e){ return ''; }
  }

  /* Start from the widget's own request - captured by the wrapper, or read
     back from resource timing when it went out before this script ran - so
     the shop domain, locale and cache stamp match. Built by hand only when
     neither is available. */
  function stripUrl(pid){
    var u = null;
    try{
      if (window.__ppReviewWidgetUrl) u = new URL(window.__ppReviewWidgetUrl);
      if (!u) {
        var entries = performance.getEntriesByType('resource');
        for (var i = entries.length - 1; i >= 0 && !u; i--) {
          if (entries[i].name.indexOf('reviews_for_widget') === -1) continue;
          var c = new URL(entries[i].name);
          if (c.searchParams.get('product_id') === pid) u = c;
        }
      }
    }catch(e){ u = null; }
    if (!u || u.searchParams.get('product_id') !== pid) {
      u = new URL('https://cdn.judge.me/reviews/reviews_for_widget');
      u.searchParams.set('product_id', pid);
      u.searchParams.set('translation_locale', (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en');
      u.searchParams.set('widget_theme', 'standard');
      if (window.Shopify && Shopify.shop) u.searchParams.set('shop_domain', Shopify.shop);
      u.searchParams.set('platform', 'shopify');
    }
    u.searchParams.set('page', '1');
    u.searchParams.set('sort_by', 'with_pictures');
    ['sort_dir', 'filter_rating', 'search'].forEach(function(k){ u.searchParams.delete(k); });
    return u.toString();
  }

  function loadStrip(){
    if (strip.state !== 'idle') return;
    var pid = productId();
    if (!pid) return;
    strip.state = 'loading';
    function done(){ strip.state = strip.items.length ? 'ready' : 'empty'; schedule(); }
    try{
      /* XHR rather than fetch on purpose: this request must not pass through
         the query wrapper, which would rewrite it to the visitor's filter and
         count it as one of the widget's own requests. */
      var xhr = new XMLHttpRequest();
      xhr.open('GET', stripUrl(pid));
      xhr.timeout = 15000;
      xhr.onload = function(){
        try{
          var data = JSON.parse(xhr.responseText);
          (data.reviews || []).forEach(function(r){
            (r.pictures_urls || []).forEach(function(p){
              if (strip.items.length >= STRIP_MAX || !p || !r.uuid) return;
              var src = reviewImage(p.small || p.compact || p.original);
              if (src) strip.items.push({ uuid: String(r.uuid), src: src });
            });
          });
        }catch(e){}
        done();
      };
      xhr.onerror = done;
      xhr.ontimeout = done;
      xhr.send();
    }catch(e){ done(); }
  }

  function thumbFor(uuid){
    var items = document.querySelectorAll('.jm-review-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('review-uuid') === uuid) return items[i].querySelector('[class*="highlight-thumbnail"]');
    }
    return null;
  }

  /* Judge.me's viewer renders its own copy of the review after the tap, and
     nothing guarantees a widget mutation afterwards to trigger the card
     reskin - so run it twice over the next second, and the viewer shows the
     same ledger card a tap in the list gets. */
  function openThumb(thumb){
    thumb.click();
    setTimeout(run, 350);
    setTimeout(run, 1200);
  }

  var openTimer = 0;
  function openReview(uuid){
    if (!uuid) return;
    var thumb = thumbFor(uuid);
    if (thumb) { openThumb(thumb); return; }
    /* Not in the list right now: the visitor has filtered or sorted it away.
       Put the list back on photo reviews - the query the strip was built
       from - and open the review as soon as Judge.me has rendered it again. */
    Q.sort = 'newest'; Q.photos = true; Q.rating = ''; Q.search = '';
    if (panelSync) panelSync();
    paintHistogram();
    refetch();
    clearInterval(openTimer);
    var tries = 0;
    openTimer = setInterval(function(){
      var t = thumbFor(uuid);
      if (t || ++tries > 32) { clearInterval(openTimer); if (t) openThumb(t); }
    }, 250);
  }

  function buildStrip(){
    var host = node('div', 'pp-jm-photos');
    var track = node('div', 'pp-jm-photos__track');
    track.setAttribute('role', 'group');
    track.setAttribute('aria-label', tr('customerPhotos', 'Customer photos'));
    strip.items.forEach(function(it){
      /* a div, not a <button>: main-product.liquid's action-row layout forces
         width:100% !important onto the first button inside every non-filter
         child of this row, which would stretch the first tile across it */
      var tile = node('div', 'pp-jm-photos__tile');
      tile.setAttribute('role', 'button');
      tile.setAttribute('tabindex', '0');
      tile.setAttribute('aria-label', tr('openPhoto', 'Open review photo'));
      tile.setAttribute('data-uuid', it.uuid);
      var img = node('img');
      img.alt = '';
      img.width = 96;
      img.height = 96;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      img.src = it.src;
      tile.appendChild(img);
      track.appendChild(tile);
    });

    /* Mouse drag on desktop; touch already swipes natively and never enters
       here. Snapping is off while the pointer holds the strip - otherwise
       every step of the drag is pulled back to a photo, which is what made it
       feel sticky - the pointer is captured so leaving the strip mid-drag
       does not drop it, and letting go glides on at the drag's own speed
       before snapping comes back. A drag that moved is not a tap, so the
       click it ends with is swallowed. */
    var drag = null, dragged = false, glideT = 0;
    track.addEventListener('pointerdown', function(e){
      dragged = false;
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      clearTimeout(glideT);
      drag = { id: e.pointerId, x: e.clientX, left: track.scrollLeft, lastX: e.clientX, lastT: e.timeStamp, v: 0 };
    });
    track.addEventListener('pointermove', function(e){
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!dragged) {
        if (Math.abs(dx) < 6) return;
        dragged = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(drag.id); } catch (err) {}
      }
      var dt = e.timeStamp - drag.lastT;
      if (dt > 0) drag.v = (e.clientX - drag.lastX) / dt;
      drag.lastX = e.clientX; drag.lastT = e.timeStamp;
      track.scrollLeft = drag.left - dx;
    });
    function endDrag(){
      if (!drag) return;
      var v = drag.v; drag = null;
      if (!dragged) return;
      track.scrollBy({ left: -v * 220, behavior: 'smooth' });
      glideT = setTimeout(function(){ track.classList.remove('is-dragging'); }, 450);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function(e){
      if (dragged) { dragged = false; e.preventDefault(); return; }
      var tile = e.target.closest ? e.target.closest('.pp-jm-photos__tile') : null;
      if (tile) openReview(tile.getAttribute('data-uuid'));
    });
    track.addEventListener('keydown', function(e){
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var tile = e.target.closest ? e.target.closest('.pp-jm-photos__tile') : null;
      if (!tile) return;
      e.preventDefault();
      openReview(tile.getAttribute('data-uuid'));
    });

    host.appendChild(track);
    return host;
  }

  function ensureStrip(){
    try{
      var actions = document.querySelector('.jm-action-buttons.pp-actions-row');
      if (!actions) return;
      loadStrip();
      if (strip.state !== 'ready') return;
      /* built once and kept: if Judge.me re-renders the row, the same strip
         (listeners, scroll position) goes back in rather than a new one */
      var host = strip.host || (strip.host = buildStrip());
      var filters = null;
      for (var i = 0; i < actions.children.length; i++) {
        if (actions.children[i].classList.contains('jm-filters__buttons')) filters = actions.children[i];
      }
      if (filters) { if (host.nextElementSibling !== filters) actions.insertBefore(host, filters); }
      else if (host.parentNode !== actions) actions.appendChild(host);
    }catch(e){}
  }

  /* 3a) Move a review's photo (Judge.me renders it as `.jm-frame.jm-highlight-thumbnail`,
     a flex-row sibling of the content column - the small square parked on the right that
     needed replacing) to be the card's first DOM child, so CSS can render it as a full-width
     header instead. Moves the real node (not a clone) so lazy-load/src stays intact.
     No one-time flag: Judge.me's Vue layer re-renders a card's children (e.g. once a lazy
     image resolves) and silently reverts a plain DOM move while leaving the outer
     `.jm-review-item` element itself in place, so this re-checks and re-fixes on every
     buildCards() pass instead of trusting a stale "already moved" marker. */
  function movePhoto(card){
    var frame = card.querySelector('[class*="highlight-thumbnail"]');
    if (!frame || !frame.querySelector('img')) return;
    frame.classList.add('pp-rc-photo');
    card.classList.add('pp-rc-compact');   // grid layout only for cards that have a photo
    if (card.lastElementChild !== frame) {
      card.appendChild(frame);
    }
    // Judge.me hard-codes width:250px + max-width:250px on its thumbnail frame,
    // in a stylesheet that loads after ours - inline !important is the only
    // thing that reliably wins. Compact-row spec: 56px square, small radius token.
    frame.style.setProperty('width', '56px', 'important');
    frame.style.setProperty('height', '56px', 'important');
    frame.style.setProperty('max-width', 'none', 'important');
    frame.style.setProperty('border-radius', 'var(--pp-r-sm, 8px)', 'important');
    frame.style.setProperty('margin', '0', 'important');
  }

  /* Judge.me's own Vue-scoped stylesheet sets an explicit `flex-basis` (a legacy value
     that stretched the content column to match the thumbnail's height when they sat side
     by side as flex siblings) on `.jm-review-item__content`/`__body` - a same-specificity,
     later-loaded rule a plain CSS !important override can't reliably beat, AND one that
     `height` alone doesn't touch: `.jm-review-item__body` is a column flex container (our
     own override), so its flex-item children size on the main axis via `flex-basis`, not
     `height` - overriding only `height` left the real 300px `flex-basis` untouched, which
     is what was actually reserving the blank space. Inline styles always win over any
     stylesheet rule, so force the whole flex shorthand there instead of fighting it. */
  function collapseReservedHeight(card){
    ['.jm-review-item__content', '.jm-review-item__body', '.jm-review-item > .jm-stack']
      .forEach(function(sel){
        card.querySelectorAll(sel).forEach(function(el){
          el.style.setProperty('height', 'auto', 'important');
          el.style.setProperty('min-height', '0', 'important');
          el.style.setProperty('flex', '0 1 auto', 'important');
        });
      });
  }

  /* 3) Rebuild each review-card header: avatar (Judge.me's own initial) + name, verified after name, stars beneath, date top-right */
  function buildCards(){
    document.querySelectorAll('.jm-review-item').forEach(function(card){
      try{
        movePhoto(card);
        collapseReservedHeight(card);
        var content = card.querySelector('.jm-review-item__content') || card;
        var head = card.querySelector('.pp-rc-head');
        if(!head){
          var nameEl = card.querySelector('.jm-reviewer-info__name');
          if(!nameEl) return;
          var name = txt(nameEl);
          if(!name) return;
          var im = name.match(/[A-Za-z0-9]/);
          var starIcon = card.querySelector('.jm-star-rating__font-icon');
          var starsEl = card.querySelector('.jm-star-rating') || (starIcon ? starIcon.parentNode : null);
          // date: prefer a real timestamp element; fall back to a regex leaf scan (also covers localized dates better)
          var dateEl = card.querySelector('time, [datetime], [class*="timestamp"], [class*="review-date"]');
          if (!dateEl) {
            var leaves = card.querySelectorAll('*');
            for (var i = 0; i < leaves.length; i++){
              var el = leaves[i]; if(el.children.length) continue; var t = txt(el);
              if(/^\d{1,2}[\/.\-]\d{1,2}[\/.\-]\d{2,4}$/.test(t) || /^\d+\s+\w+\s+ago$/i.test(t) || /^[A-Za-z]+\.?\s+\d{1,2},?\s+\d{4}$/.test(t)){ dateEl = el; break; }
            }
          }
          var jmAv = card.querySelector('.jm-reviewer-avatar__initial, [class*="reviewer-avatar"]');
          var av;
          if(jmAv){ av = jmAv.cloneNode(true); av.classList.add('pp-rc-av'); }
          else { av = document.createElement('div'); av.className = 'pp-rc-av'; av.textContent = im ? im[0].toUpperCase() : '?'; }
          head = document.createElement('div'); head.className = 'pp-rc-head';
          var idc = document.createElement('div'); idc.className = 'pp-rc-id';
          var nm = document.createElement('div'); nm.className = 'pp-rc-name'; nm.appendChild(document.createTextNode(name));
          idc.appendChild(nm);
          if(starsEl){ var sc = starsEl.cloneNode(true); if(sc.classList) sc.classList.add('pp-rc-starsclone'); idc.appendChild(sc); }
          head.appendChild(av); head.appendChild(idc);
          if(dateEl){ var dt = document.createElement('div'); dt.className = 'pp-rc-date'; dt.textContent = txt(dateEl); head.appendChild(dt); }
          content.insertBefore(head, content.firstChild);
          // collapse the now-empty native header block (kills the big gap), guarding the body text + photos
          var bodyEl = content.querySelector('p');
          var hdrRow = nameEl;
          while(hdrRow.parentElement && hdrRow.parentElement !== content && hdrRow.parentElement !== card && hdrRow.parentElement !== head) hdrRow = hdrRow.parentElement;
          if(hdrRow && hdrRow !== content && hdrRow !== card && hdrRow !== head && !(bodyEl && hdrRow.contains(bodyEl)) && !hdrRow.querySelector('img')) hdrRow.classList.add('pp-rc-hide');
          nameEl.classList.add('pp-rc-hide');
          if(starsEl && starsEl.classList) starsEl.classList.add('pp-rc-hide');
          if(dateEl && dateEl.classList) dateEl.classList.add('pp-rc-hide');
          if(jmAv && jmAv.classList) jmAv.classList.add('pp-rc-hide');
        }
        // verified: ensure a "Verified" sits right after the name (every run -> catches late render)
        var nmRow = head.querySelector('.pp-rc-name');
        if(nmRow && !nmRow.querySelector('.pp-rc-verif')){
          var nv = null;
          card.querySelectorAll('[class*="verified"]').forEach(function(e){ if(!nv && !(e.closest && e.closest('.pp-rc-head'))) nv = e; });
          if(nv){
            var vf = document.createElement('span'); vf.className = 'pp-rc-verif';
            vf.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Verified';
            nmRow.appendChild(vf);
          }
        }
        // hide Judge.me's own verified badges (every run); keep ours
        card.querySelectorAll('[class*="verified"]').forEach(function(e){ if(!e.classList.contains('pp-rc-verif') && !(e.closest && e.closest('.pp-rc-head'))) e.classList.add('pp-rc-hide'); });
        ledger(card, head, content);
      }catch(e){}
    });
  }

  /* ---- LEDGER ----
     Name, the verified badge and the date all belong to one line: they are
     the same fact (who wrote this, and when), so they read as one row with
     the date pushed out to the right margin. The stars then sit on their own
     line under it, still inside the identity column so the avatar spans both.

     The body is left exactly as Judge.me wrote it - no bold opening clause,
     no derived headline. */
  function ledger(card, head, content){
    if(!head || head.parentNode.querySelector('.pp-rc-meta')) return;
    var stars = head.querySelector('.pp-rc-starsclone');
    var date  = head.querySelector('.pp-rc-date');
    if(!stars && !date) return;
    var meta = document.createElement('div');
    meta.className = 'pp-rc-meta';
    meta.appendChild(stars || document.createElement('span'));
    if(date) meta.appendChild(date);
    if(head.nextSibling) head.parentNode.insertBefore(meta, head.nextSibling);
    else head.parentNode.appendChild(meta);
  }

  var timer = 0, obs = null, scoped = false;
  /* moveVideoStrip is retired: the rail is now the hero of the stats section
     directly above this widget, so it no longer needs re-parenting in here.
     Re-parenting it also broke the rail's cached set-width. */
  function run(){ buildSummary(); styleHistogram(); moveHistogram(); moveGallery(); moveSort(); ensureFilter(); ensureStrip(); layout(); buildCards(); maybeScope(); }
  function schedule(){ if(timer) return; timer = setTimeout(function(){ timer = 0; run(); }, 120); }
  // Start by watching the body (the widget loads async), then narrow the observer to the
  // widget itself once it exists so we're not re-running on every unrelated DOM change.
  function maybeScope(){
    if(scoped || !obs) return;
    var w = document.querySelector('.jm-review-widget');
    if(w){ scoped = true; obs.disconnect(); obs.observe(w, { childList: true, subtree: true }); }
  }
  function start(){
    obs = new MutationObserver(schedule); run(); obs.observe(document.body, { childList: true, subtree: true });
    /* main-product.liquid re-lays the action row every 500ms for its first
       40s and on every resize. Style changes are not childList mutations, so
       the observer never sees them - re-assert the stack on the same rhythm,
       a little longer, and after its resize handler (registered earlier, so
       it runs first). Each pass is reads only unless something changed. */
    var ticks = 0;
    var heal = setInterval(function(){ layout(); if (++ticks > 100) clearInterval(heal); }, 500);
    window.addEventListener('resize', layout);
  }
  if(document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
